<template>
  <my-swiper
    :autoplay="3000"
    class="swiper"
    indicator-color="white"
    ref="commonSwiper"
  >
    <my-swipe-item
      :key="index"
      @click="tapSwiper(configer)"
      v-for="(configer, index) in imgList"
    >
      <img v-lazy="configer.img" />
    </my-swipe-item>
  </my-swiper>
</template>

<script>
import { Swipe, SwipeItem } from 'vant'
import { mapState } from 'vuex'
export default {
  name: 'swiper',
  components: {
    mySwiper: Swipe,
    mySwipeItem: SwipeItem
  },
  props: {
    imgList: {
      type: Array
    }
  },
  data () {
    return {
      routers: ['pageCh', 'pageFling', 'positionColumns', 'supermarketFlashSale']
    }
  },
  computed: {
    ...mapState('store', [
      'Authorization', 'clueterInfo'
    ])
  },
  activated () {
    this.$refs.commonSwiper.resize()
  },
  methods: {
    tapSwiper (arg) {
      if (arg.cluster_id) {
        if (this.Authorization) {
          if (this.clueterInfo.includes(Number(arg.cluster_id))) {
            if (arg.is_login) {
              if (this.Authorization) {
                if (arg.is_ajax) {
                  this.jumpUrl(arg.url)
                } if (arg.title.includes('_white')) {
                  this.fetchWhiteList(arg.url)
                } else {
                  this.$router.push(arg.url)
                }
              } else {
                this.$router.push({ name: 'login' })
              }
            } else {
              if (arg.url) {
                if (arg.is_href) {
                  location.href = arg.url
                  return false
                }
                if (this.routers.includes(arg.url)) {
                  this.$router.push({
                    name: arg.url,
                    query: { column: arg.column, title: arg.title, pCode: arg.position_code }
                  })
                } else {
                  this.$router.push(arg.url)
                }
              } else {
                // this.$toast('敬请期待')
              }
            }
          } else {
            this.$toast('抱歉，您没有权限')
          }
        } else {
          this.$router.push({ name: 'login' })
        }
      } else if (arg.is_login) {
        if (this.Authorization) {
          if (arg.is_ajax) {
            this.jumpUrl(arg.url)
          } if (arg.title.includes('_white')) {
            this.fetchWhiteList(arg.url)
          } else {
            this.$router.push(arg.url)
          }
        } else {
          this.$router.push({ name: 'login' })
        }
      } else {
        if (arg.url) {
          if (arg.is_href) {
            location.href = arg.url
            return false
          }
          if (this.routers.includes(arg.url)) {
            this.$router.push({
              name: arg.url,
              query: { name: arg.url, column: arg.column, title: arg.title, pCode: arg.position_code }
            })
          } else {
            this.$router.push(arg.url)
          }
        } else {
          // this.$toast('敬请期待')
        }
      }
    },
    async jumpUrl (url) {
      const res = await this.$axios.get(url)
      if (res.status === 200) {
        const { code, msg, data } = res.data
        if (code === 0) {
          // console.log(data)
          window.location.href = data
        } else if (code === -1) {
          // this.$router.push({ name: 'login' })
        } else {
          this.$toast(msg)
        }
      }
    },
    async fetchWhiteList (url) {
      const res = await this.$axios.get('/api/goods/whiteWgold_if')
      if (res.status === 200) {
        const { code, msg } = res.data
        if (code === 0) {
          location.href = url
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.swiper {
  img {
    min-width: 7.1rem;
    max-height: 3.8rem;
    object-fit: contain;
  }
  img[lazy='loading'],
  img[lazy='error'] {
    opacity: 0;
  }
}
</style>
